<template>
  <div class="sr_box">
    <div class="sr_bold sr_green">
      {{ propObj.inizio | date_reverse_filter }}
    </div>
    <div class="truncate sr_small" :title="propObj.obj_s.address | pipe_filter">
      {{ propObj.obj_s.address | pipe_filter }}
    </div>
    <div class="sr_bold sr_red">
      {{ propObj.fine | date_reverse_filter
      }}<span v-if="propObj.tail > 0">&nbsp;&nbsp;IN CORSO</span>
    </div>
    <div class="truncate sr_small" :title="propObj.obj_e.address | pipe_filter">
      {{ propObj.obj_e.address | pipe_filter }}
    </div>
    <div class="sr_bold">
      <table width="100%">
        <tr>
          <td width="32%">Km&nbsp;{{ propObj.km }}</td>
          <td width="32%">
            {{ min2hour(propObj.minuti) }}
          </td>
          <td width="32%">
            <span v-if="propObj.tappe.length > 0"
              >Soste&nbsp;{{ propObj.tappe.length }}
              <img
                height="9"
                width="9"
                :src="[
                  isDrillOn ? 'images/drill_on.png' : 'images/drill_off.png',
                ]"
                @click.stop="drill"
            /></span>
          </td>
        </tr>
      </table>
    </div>
    <div v-if="isDrillOn" class="drill_table">
      <table>
        <tr v-for="item in propObj.tappe" :key="item.inizio">
          <td>
            <div class="tablemin9">
              {{ item.inizio | date_reverse_filter }}
            </div>
          </td>
          <td>
            <div class="tablemin9">
              {{ min2hour(item.minuti) }}
            </div>
          </td>
          <td>
            <div
              class="truncate80 sr_small"
              :title="item.obj_e.address | pipe_filter"
            >
              {{ item.obj_e.address | pipe_filter_short }}
            </div>
          </td>
          <td>
            <span class="button is-info is-tiny" @click.stop="showPos(item)"
              >&nbsp;</span
            >
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import { ServiceBus } from '../../ServiceBus.js'
export default {
  name: 'TripBox',
  props: {
    propObj: {
      default: null,
      type: Object,
    },
    selectedCod: {
      default: '',
      type: String,
    },
  },
  data() {
    let data = {
      isDrillOn: false,
    }
    return data
  },

  methods: {
    goHistory() {
      ServiceBus.$emit('showHistory')
    },
    drill() {
      const vm = this
      vm.isDrillOn = !vm.isDrillOn
    },
    showPos(sosta) {
      ServiceBus.$emit('centerSosta', sosta)
    },
    min2hour(mintot) {
      let hours = Math.trunc(mintot / 60)
      let min = mintot % 60
      return hours + 'h ' + min + 'm'
    },
  },
}
</script>
